import { Container, Point } from "pixi.js";

export class MaskContainer extends Container {
    public containsPoint(point: Point): boolean {
        for (const child of this.children) {
            if (typeof (child as any).containsPoint === "function") {
                if ((child as any).containsPoint(point)) return true;
            }
        }
        return false;
    }
}